export default __webpack_public_path__ + "static/media/room.eefb489f.svg";